import React from "react";

const Mentor = ({fillColor}) => {
  return (
<svg
  width="19"
  height="19"
  viewBox="0 0 200 200"
  xmlns="http://www.w3.org/2000/svg"
>
  <polygon
    points="10,190 10,10 60,10 100,90 140,10 190,10 190,190 150,190 150,60 100,140 50,60 50,190"
    fill={fillColor ?? "green"}
    stroke="black"
    stroke-width={fillColor === "white" ? "1.5rem": "0.5rem"}
  />
</svg>
  );
};

export default Mentor;
